import { Link } from 'react-router-dom';
import { useState } from 'react';

const FORM_SUBMIT_URL = 'http://ipv6c.com/';

export default function Footer() {
  const [email, setEmail] = useState('');
  const [formStatus, setFormStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [formError, setFormError] = useState('');

  const handleNewsletterSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);
    const honeypotVal = (formData.get('website_alt') as string || '').trim();
    if (honeypotVal !== '') {
      setFormStatus('success');
      setEmail('');
      setTimeout(() => setFormStatus('idle'), 3000);
      return;
    }
    formData.delete('website_alt');
    setFormStatus('loading');
    setFormError('');
    try {
      const params = new URLSearchParams();
      formData.forEach((value, key) => {
        params.append(key, value.toString());
      });
      const response = await fetch(FORM_SUBMIT_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: params.toString(),
      });
      const responseText = await response.text();
      let parsed: any = {};
      try { parsed = JSON.parse(responseText); } catch { /* ignore */ }
      if (response.ok && parsed?.code === 'OK') {
        setFormStatus('success');
        setEmail('');
      } else {
        const serverMsg = parsed?.meta?.message || parsed?.message || '';
        if (serverMsg.includes('spam')) {
          setFormStatus('error');
          setFormError('提交失败，请稍后重试');
        } else {
          setFormStatus('error');
          setFormError(serverMsg || '提交失败，请稍后重试');
        }
      }
    } catch {
      setFormStatus('error');
      setFormError('网络错误，请检查连接后重试');
    }
    setTimeout(() => setFormStatus('idle'), 3000);
  };

  const footerLinks = [
    {
      title: '漫画分类',
      links: [
        { label: '恋爱漫画', path: '/category/romance' },
        { label: '奇幻漫画', path: '/category/fantasy' },
        { label: '动作漫画', path: '/category/action' },
        { label: '悬疑漫画', path: '/category/suspense' },
      ],
    },
    {
      title: '热门推荐',
      links: [
        { label: '最新更新', path: '/' },
        { label: '高分作品', path: '/category/drama' },
        { label: '完结作品', path: '/category/comedy' },
        { label: '新作上架', path: '/' },
      ],
    },
    {
      title: '关于平台',
      links: [
        { label: '品牌介绍', path: '/about' },
        { label: '联系方式', path: '/about' },
        { label: '用户协议', path: '/about' },
        { label: '隐私政策', path: '/about' },
      ],
    },
    {
      title: '帮助支持',
      links: [
        { label: '常见问题', path: '/' },
        { label: '阅读指南', path: '/about' },
        { label: '反馈建议', path: '/about' },
        { label: '商务合作', path: '/about' },
      ],
    },
  ];

  return (
    <footer className="bg-accent-900 text-background-50" role="contentinfo">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="flex flex-col lg:flex-row gap-10">
          <div className="lg:w-1/3">
            <Link to="/" className="flex items-center gap-2 mb-6 whitespace-nowrap">
              <span className="w-8 h-8 flex items-center justify-center">
                <i className="ri-book-open-line text-xl text-accent-300"></i>
              </span>
              <span className="text-xl font-heading font-bold text-background-50">
                韩漫画网
              </span>
            </Link>
            <p className="text-base text-background-50/70 leading-relaxed mb-6 font-heading">
              海量正版漫画在线阅读平台
              <br />
              安全可靠，每日更新
            </p>
            <form
              id="newsletter-form"
             
              onSubmit={handleNewsletterSubmit}
              className="flex flex-col gap-2"
            >
              <div className="flex items-center gap-0">
                <input
                  type="email"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="输入邮箱订阅更新"
                  required
                  className="flex-1 px-4 py-2.5 text-sm bg-background-50/10 border border-background-50/20 rounded-l-full text-background-50 placeholder:text-background-50/40 focus:outline-none focus:border-background-50/40"
                />
                <input
                  type="text"
                  name="website_alt"
                  tabIndex={-1}
                  autoComplete="off"
                  aria-hidden="true"
                  readOnly
                />
                <button
                  type="submit"
                  disabled={formStatus === 'loading'}
                  className="px-4 py-2.5 bg-accent-500 text-background-50 rounded-r-full hover:bg-accent-400 transition-colors duration-200 whitespace-nowrap cursor-pointer disabled:opacity-60"
                >
                  <span className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-mail-send-line"></i>
                  </span>
                </button>
              </div>
              {formStatus === 'success' && (
                <p className="text-xs text-accent-300">订阅成功！感谢您的关注。</p>
              )}
              {formStatus === 'error' && (
                <p className="text-xs text-primary-300">{formError}</p>
              )}
            </form>
          </div>

          <div className="lg:w-2/3 grid grid-cols-2 sm:grid-cols-4 gap-6">
            {footerLinks.map((column) => (
              <div key={column.title}>
                <h4 className="text-sm font-medium text-background-50 mb-4">
                  {column.title}
                </h4>
                <ul className="flex flex-col gap-2.5">
                  {column.links.map((link) => (
                    <li key={link.label}>
                      <Link
                        to={link.path}
                        className="text-sm text-background-50/60 hover:text-background-50/90 transition-colors duration-200 whitespace-nowrap"
                      >
                        {link.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="border-t border-background-50/10">
        <div className="w-full px-4 md:px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-50/50">
            &copy; {new Date().getFullYear()} 韩漫画网 版权所有
          </p>
          <div className="flex items-center gap-3">
            {[
              { icon: 'ri-wechat-line', label: '微信' },
              { icon: 'ri-weibo-line', label: '微博' },
              { icon: 'ri-bilibili-line', label: 'B站' },
              { icon: 'ri-links-line', label: '抖音' },
            ].map((social) => (
              <a
                key={social.label}
                href="#"
                className="w-8 h-8 flex items-center justify-center rounded-lg border border-background-50/20 text-background-50/60 hover:text-background-50 hover:border-background-50/40 transition-colors duration-200 cursor-pointer"
                aria-label={social.label}
                rel="nofollow"
              >
                <i className={`${social.icon} text-sm`}></i>
              </a>
            ))}
          </div>
          <Link
            to="/about"
            className="text-xs text-background-50/50 hover:text-background-50/70 transition-colors duration-200 whitespace-nowrap"
          >
            隐私政策
          </Link>
        </div>
      </div>
    </footer>
  );
}